import React from 'react';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { ArrowDropDown } from '@mui/icons-material';
import theme from 'config/theme';
import styles from './menuArrow.styles';

const MenuArrow = ({ expanded }) => {
  return expanded ? (
    <ArrowDropDown
      data-testid="ArrowDropDown"
      color={theme.customValues.sidebar.textColor}
      sx={styles.menuItemIcon}
    />
  ) : (
    <ArrowRightIcon
      data-testid="ArrowRightIcon"
      color={theme.customValues.sidebar.textColor}
      sx={styles.menuItemIcon}
    />
  );
};

export default MenuArrow;
